import { render, staticRenderFns } from "./TeacherNotifications.vue?vue&type=template&id=4a8a7d99&"
import script from "./TeacherNotifications.vue?vue&type=script&lang=js&"
export * from "./TeacherNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports